<template>
    <div class="top_header_ b_border_">
      <div class="w1000_ clearfix_">
        <img class="logo_" :src="logoUrl" />
        <!-- <label class="com_">国际领先的保险和投资机构认证平台</label> -->
        <!-- <span class="f_r_" @click="backTo">返回首页</span> -->
      </div>
    </div>
</template>
<script>
import Storage from '@/utils/storage'
import api from "@/utils/api";
import { getToken, setToken,getLogined,getUserInfo,setLogined,cacheUserInfo} from '@/utils/authorized'
export default {
    data () {
        return {
          logoUrl:'',
          servicePhone:'',
          storeName:'',
           isLogined: getUserInfo()? true : false,
        }
    },
    mounted (){
      this.fetchData()
    },
    methods:{
      fetchData(){
          let userId = 792713  //后台配置用户:GDSC01 GDsc01-01
        if(window.location.href.indexOf('run4wd') > -1){
          userId = 720369
        }
        api.queryStore({
              userId:userId
          }).then(res => res.data).then(data => {
            if(data.returnCode === '00' && data.content!=''){
                this.logoUrl=data.content.coreStoreDto.logoUrl
                this.servicePhone=data.content.coreStoreDto.servicePhone
                this.storeName=data.content.coreStoreDto.storeName
            }
        })
      },
      backTo(){
        if(this.isLogined===true){
              this.$router.push({
                name: 'gd-home'
              });
        }else{
            this.$router.push({
              name: 'gd-login'
            });
        }
      }
    }
}
</script>
<style lang="scss" scoped>
  .top_header_ {
    background: rgba(255, 255, 255, 0.8);
    padding: 0 0 0 43px;
    height: 67px;
    line-height: 67px;
    text-align: left;
    .com_ {
      color: #333333;
      font-size: 15px;
      margin-left: 42px;
    }

    .logo_ {
      width: 119px;
      height: 28px;
      object-fit:cover;
    }
  }
</style>
